import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { loginSuccess, logoutSuccess } from '../../auth/store/actions'

import { DEFAULT_INFO, DEFAULT_LOGGED_IN } from './defaultState'

const loggedIn = handleActions({
  [loginSuccess]: () => true,
  [logoutSuccess]: () => false
}, DEFAULT_LOGGED_IN)

const info = handleActions({
  [loginSuccess]: (state, { payload }) => payload,
  [logoutSuccess]: () => DEFAULT_INFO
}, DEFAULT_INFO)

export default combineReducers({
  loggedIn,
  info
})
